import type { IconData } from '@stacksjs/iconify-core'

export const appleAlt: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M17.594 12.625a4.52 4.52 0 0 1 2.162-3.805a4.67 4.67 0 0 0-3.658-1.984c-1.558-.158-3.04.917-3.83.917c-.789 0-2.008-.894-3.3-.87A4.9 4.9 0 0 0 4.83 9.392c-1.763 3.06-.45 7.593 1.267 10.076c.84 1.214 1.843 2.581 3.158 2.532c1.268-.05 1.746-.82 3.277-.82c1.53 0 1.961.82 3.3.795c1.364-.025 2.229-1.239 3.062-2.457a11 11 0 0 0 1.384-2.845a4.42 4.42 0 0 1-2.684-4.047Z\"/><path fill=\"currentColor\" d=\"M15.216 5.04A5.56 5.56 0 0 0 16.536 1a5.67 5.67 0 0 0-3.73 1.92l-.02.047a5.56 5.56 0 0 0-1.32 4.04a5.67 5.67 0 0 0 3.73-1.92Z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default appleAlt
